import type { FocusEvent } from 'react';
import { useState } from 'react';
import { ConnectedInput } from '@eti/form';
import { useProperty, useTranslation, useSnowplowTracking } from '@eti/providers';
import { constants, persistInputData } from '@eti/utils';
import { TRAVELER_DETAILS } from '../../../../constants/formNamesConstants';
import { contactFields, fieldRestrictions } from '../../constants/formFields';

const { MOUSE_FLOW_CLASS_NAMES } = constants;

const Email = () => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();
  const [hasChanged, setHasChanged] = useState(false);

  const handleOnChange = () => {
    if (isSnowplowTrackingEnabled && !hasChanged) {
      sendTrackEvent({
        category: 'Traveler Details',
        action: 'Input',
        label: 'Email',
      });
      setHasChanged(true);
    }
  };

  const handleOnBlur = p('IbeClient.TravelerDetails.PersistFormData.Enabled')
    ? (event: FocusEvent<HTMLInputElement>) =>
        persistInputData(TRAVELER_DETAILS, contactFields.EMAIL)(event.target.value)
    : undefined;

  return (
    <ConnectedInput
      autoCapitalize="off"
      autoCorrect="off"
      className={MOUSE_FLOW_CLASS_NAMES}
      data-testid="traveler-email-input"
      label={t('ContactForm.Email.Label')}
      maxLength={fieldRestrictions.MAX_CHARS}
      name={contactFields.EMAIL}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      placeholder={t('Input.Mail.Placeholder')}
      shouldMarkInputAsRequired
      spellCheck="false"
      type="email"
      validationRuleName={contactFields.EMAIL}
    />
  );
};

export default Email;
